import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import PageHeader from '../../../components/ui/pageHeader/PageHeader'
import { PaymentList } from '../../../components/authenticated/payments/paymentList/PaymentList'

import {
  PAYMENT_FILTERS,
  PaymentFilterType,
} from '../../../types/payment/payment'

const Payments = () => {
  const { t } = useTranslation('payments')
  const [searchParams, setSearchParams] = useSearchParams()

  const requestedTab = searchParams.get('tab')?.toUpperCase()
  const initialTab =
    PAYMENT_FILTERS.find(filter => filter === requestedTab) ?? 'ALL'

  const [tab, setTab] = useState<PaymentFilterType>(initialTab)

  const filterLabel = t(`payments.payment-list.filter.${tab.toLowerCase()}`)

  return (
    <div>
      <PageHeader
        title={{
          eyebrow: t('payments.page-header.eyebrow', {
            filterType: filterLabel,
          }),
          h1: t('payments.page-header.title'),
        }}
        sub={t('payments.page-header.sub')}
      />

      <PaymentList
        tab={tab}
        onTabChange={nextTab => {
          setTab(nextTab)
          setSearchParams(
            nextTab === 'ALL' ? {} : { tab: nextTab.toLowerCase() }
          )
        }}
      />
    </div>
  )
}

export default Payments
